import React from 'react';

import { twMerge } from 'tailwind-merge';

import { useAvailableSingleCallJobs } from 'state/context/freelancer/FreelancerAvailableJobs';

import { createLocale } from 'locales';

import Typography from 'components/typography/typography';

import { formatDateToLocaleNetherlands } from 'utils/display-text-formatter';

import Icon from 'components/icon/icon';

import AcceptedJobsNotifier from './AcceptedJobsNotifier';

interface DateholderProps {
  date: string;
  index?: number;
}
const localize = createLocale('freelancerAvailableJobsLocales');

const DateHolder: React.FC<DateholderProps> = ({ date, index }) => {
  const { acceptedJobs } = useAvailableSingleCallJobs();
  const todayAcceptedJobs = acceptedJobs.data.filter(
    (job) => job.date === date,
  );

  const containerClassName = twMerge(
    'container flex items-start justify-start flex-col py-2',
    'md:flex-row md:justify-between md:items-center',
    'pl-7 mb-4 mt-6 border rounded-md',
    'border-slate300 h-auto md:h-16  bg-veryLightBlue',
  );

  const notify =
    !acceptedJobs.error &&
    !acceptedJobs.isLoading &&
    acceptedJobs.data &&
    todayAcceptedJobs.length > 0;

  return (
    <>
      <div key={index} className={containerClassName}>
        <Typography
          variant="page-subheading"
          as="h3"
          className="text-lightGreen"
        >
          {formatDateToLocaleNetherlands(date)}
        </Typography>
        {notify && (
          <div className="flex justify-center items-center text-gray-700 mt-2 md:my-auto">
            <Icon icon="bell" size={20} />
            <Typography
              variant="body-large-bold"
              as="h3"
              className="text-gray-700 mr-2  md:mr-10 ml-3"
            >
              {localize('assignmentsOnThisDate', {
                count: todayAcceptedJobs.length,
              })}
            </Typography>
          </div>
        )}
      </div>
      <AcceptedJobsNotifier date={date} />
    </>
  );
};

export default DateHolder;
